import { BaseApi } from '@/main/baseApi';

import { DependentTableNames, DMS_MODULE, EXISTUJICI_ZAPUJCKY, NAME, TRZBY } from './constants';

class VozidlaPujcovnyProvider extends BaseApi {
	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case TRZBY:
				return `/${this.area}/${this.controller}/${TRZBY}Schema`;
			case EXISTUJICI_ZAPUJCKY:
				return `/${this.area}/${this.controller}/${EXISTUJICI_ZAPUJCKY}Schema`;
			default:
				return `/${this.area}/${this.controller}/${tableName}Schema`;
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case TRZBY:
				return `/${this.area}/${this.controller}/${TRZBY}Rows`;
			case EXISTUJICI_ZAPUJCKY:
				return `/${this.area}/${this.controller}/${EXISTUJICI_ZAPUJCKY}Rows`;
			default:
				return `/${this.area}/${this.controller}/${tableName}Rows`;
		}
	}

	getVozidloPujcovna(VozidlopaId: string | number) {
		return this.fetch(`/${this.area}/${this.controller}/${VozidlopaId}`);
	}

	zmenaVozidla(VozidloId: number) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaVozidla`, { VozidloId });
	}
}

export const apiProvider = new VozidlaPujcovnyProvider(DMS_MODULE, NAME);
